import React, { useState, useCallback, useEffect } from 'react';
import { Box, Button, FormControl, InputLabel, TextField, Select, MenuItem, OutlinedInput } from '@mui/material';
import FileOpenIcon from '@mui/icons-material/FileOpen';

import { PricelistApis } from '../../../../hooks/apis/PricelistApis';
import './PricelistFilter.scss';

const PricelistFilter = ({ exportPricelist, textFilter, setTextFilter, setSelectFilter }) => {
  const { getPricelistFilters } = PricelistApis();
  const [groups, setGroups] = useState([]);

  const [selectedGroups, setSelectedGroups] = useState([]);

  useEffect(() => {
    setSelectFilter([...selectedGroups]);
  }, [selectedGroups, setSelectFilter]);

  const handleGroupChange = useCallback((item) => {
    setSelectedGroups(typeof item?.target?.value === 'string' ? item?.target?.value.split(',') : item?.target?.value);
  }, []);

  useEffect(() => {
    getPricelistFilters().then((data) => {
      const groupValues = data
        ?.find((f) => f.FilterName === 'Group')
        .FilterValues.sort((a, b) => a.Order - b.Order)
        .map((m) => m.Name);
      setGroups(groupValues);
    });
  }, [getPricelistFilters]);

  const clearFilter = useCallback(() => {
    setSelectedGroups([]);
    setTextFilter('');
  }, [setSelectedGroups, setTextFilter]);

  return (
    <Box className="searchBar">
      <Box className="searchTop">
        <FormControl size="small">
          <TextField
            value={textFilter}
            onChange={(item) => setTextFilter(item?.target?.value)}
            size="small"
            label="Pricelist Filter"
            fullWidth
          />
        </FormControl>

        <FormControl size="small">
            <InputLabel>Groups</InputLabel>
            <Select size="small" value={selectedGroups} onChange={handleGroupChange} input={<OutlinedInput label="Groups" />} multiple fullWidth>
              {groups.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        <Button onClick={clearFilter} variant="outlined" size="large" fullWidth>
          Clear
        </Button>
        <Button onClick={exportPricelist} variant="outlined" size="large" fullWidth>
          <FileOpenIcon />&nbsp; Export
        </Button>
      </Box>
    </Box>
  );
};

export default PricelistFilter;
